import React from 'react';

import { SimpleTooltip } from '../tooltip/SimpleTooltip';

import { Emblem } from './Emblem';

type EmblemTooltipProps = React.ComponentProps<typeof Emblem> & {
  tooltip?: string;
};

export const EmblemTooltip: React.FC<EmblemTooltipProps> = ({ text, tooltip, ...props }) => {
  return (
    <SimpleTooltip content={tooltip}>
      <Emblem text={text} {...props} disableNativeTooltip={!!tooltip} />
    </SimpleTooltip>
  );
};
